// library imports
import { Skeleton } from "antd";
import { useState, useEffect, useContext } from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
// style imports
import "../../styles/Dashboard/PVConditionAlarmContent.css";
// hook imports
import useFetch from "../../hooks/useFetch";
// context imports
import { IndexContext } from "../../context/IndexContext";
// config imports
import { MQTT_REFRESH_RATE } from "../../configs/configs";

export default function PVConditionContent({ setRefreshCheck }) {
  const [fetchWrapper] = useFetch();
  const { siteSelected, notificationApi } = useContext(IndexContext);

  const [loading, setLoading] = useState(true);

  const [noOutage, setNoOutage] = useState(true);
  const [noShading, setNoShading] = useState(true);
  const [noFuseBlow, setNoFuseBlow] = useState(true);
  const [noSoiling, setNoSoiling] = useState(true);

  const colorSetting = (condition) => {
    return condition ? { color: "green" } : { color: "red" };
  };

  const pvConditionIcon = (condition) => {
    return condition ? (
      <CheckCircleOutlined style={{ color: "green" }} />
    ) : (
      <CloseCircleOutlined style={{ color: "red" }} />
    );
  };

  function getPvConditionData() {
    fetchWrapper({
      endpoint_url: "dashboard/getPvConditionData",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
      },

      onSuccess: (response) => {
        if (response.data.length != 0) {
          setNoOutage(response.data[0]["NoOutage"]);
          setNoShading(response.data[0]["NoShading"]);
          setNoFuseBlow(response.data[0]["NoFuseBlow"]);
          setNoSoiling(response.data[0]["NoSoiling"]);
          setRefreshCheck(true);
        }
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to PV condition data.",
          description: response.statusText,
        });
      },

      onFinish: () => {
        setLoading(false);
      },
    });
  }

  useEffect(() => {
    if (siteSelected) {
      getPvConditionData();

      const timer = setInterval(() => {
        getPvConditionData();
      }, MQTT_REFRESH_RATE * 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [siteSelected]);

  return (
    <div className="h-100 w-100">
      {loading === false ? (
        <div className="pvcondition-alarm-content-container">
          <span>No Outage {pvConditionIcon(noOutage)}</span>
          <span>No Shading {pvConditionIcon(noShading)}</span>
          <span>No Fuse Blow {pvConditionIcon(noFuseBlow)}</span>
          <span>No Soiling {pvConditionIcon(noSoiling)}</span>
        </div>
      ) : (
        <Skeleton
          active={true}
          style={{ padding: "0.4rem", maxWidth: "70%", margin: "auto" }}
          paragraph={{ rows: 4 }}
        />
      )}
    </div>
  );
}

// // draft - if wants to make a doughnut chart for pv condition data
// // library imports
// import { useState } from "react";
// // component imports
// import DoughnutChart from "../common/DoughnutChart";
// import FullDoughnutChart from "../common/FullDoughnutChart";

// export default function PVConditionContent() {
//   const [data, setData] = useState([
//     {
//       name: "Outage",
//       value: 1,
//     },
//     {
//       name: "Fuse Blow",
//       value: 0,
//     },
//     {
//       name: "Shading",
//       value: 0,
//     },
//     {
//       name: "Soiling",
//       value: 0,
//     },
//   ]);

//   function valueFormatter(value) {
//     return value.toLocaleString({
//       maximumFractionDigits: 2,
//       minimumFractionDigits: 2,
//     });
//   }

//   return (
//     <div className="h-100 w-100">
//       {data.every((item) => item.value === 0) ? (
//         <FullDoughnutChart
//           data={[
//             {
//               type: "Normal",
//               percent: 100,
//               color: "#2ac41f",
//             },
//           ]}
//         />
//       ) : (
//         <DoughnutChart
//           data={[
//             {
//               name: "Outage",
//               value: 1,
//             },
//             {
//               name: "Fuse Blow",
//               value: 0,
//             },
//             {
//               name: "Shading",
//               value: 1,
//             },
//             {
//               name: "Soiling",
//               value: 0,
//             },
//           ]}
//           y="value"
//           color="name"
//           innerRadius={0.55}
//           outerRadius={0.8}
//           statisticValueFormatter={(d) => valueFormatter(d)}
//           yValueFormatter={(d) => valueFormatter(d)}
//         />
//       )}
//     </div>
//   );
// }
